export default __webpack_public_path__ + "static/media/yen2space.e895bad0.jpg";